import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import QuestionTextInput from '../UI/QuestionTextInput';
import QuestionTitleInput from '../UI/QuestionTitleInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import Swal from 'sweetalert2'

const RealMatch = (props) => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const [serviceListmulti, setServiceListmulti] = useState([{ service: "" }]);

    const handleServiceRemove = (index) => {
        const list = [...serviceList];
        list.splice(index, 1);
        setServiceList(list);
    };
    const handleServiceAdd = () => {
        console.log(serviceList);
        setServiceList([...serviceList, { service: "" }]);
    };
    const handleServiceChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...serviceList];
        list[index][name] = value;
        setServiceList(list);
    };

    const handleAnswerPhoto = async (e, index) => {
        if (e.target.type === "textarea") {
            const { name, value } = e.target;
            const list = [...serviceList];
            list[index][name] = e.target.value;
            setServiceList(list);

        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index][name] = url;;
                    serviceList(list);

                });
            } catch (err) {
                setMsg(err.message);
            }

        }


    };
    const handleAnswerSound = async (e, index) => {
        if (e.target.type === "textarea") {
            const { name, value } = e.target;
            const list = [...serviceList];
            list[index][name] = e.target.value;
            setServiceList(list);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index][name] = url;;
                    setServiceList(list);

                });
            } catch (err) {
                alert(err.message)
                setMsg(err.message);
            }

        }




        // const formData = new FormData();
        // formData.append('FormFile', e.target.files[0]);
        // try {
        //     const headerss = {
        //         "accept": "*/*",
        //         'Content-Type': 'multipart/form-data',
        //         'Access-Control-Allow-Credentials': 'false',
        //         'Authorization': 'Bearer ' + user.token
        //     }
        //     const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
        //     await axios({
        //         method: 'Post',
        //         url: url,
        //         params: {
        //             mediaType: "video"
        //         },
        //         data: formData,
        //         headers: headerss
        //     }).then(res => {
        //         console.log(res.data)
        //         console.log(res.data)
        //         let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
        //         setImagePath(url)
        //         alert("Yüklendi")
        //         const { name, value } = e.target;
        //         const list = [...serviceList];
        //         list[index][name] = url;;
        //         setServiceList(list);
        //         console.log(serviceList);
        //     });
        // } catch (err) {
        //     alert(err.message);
        //     setMsg(err.message);
        // }

    };

    const handleAnswerPhoto2 = async (e, index) => {

        if (e.target.type === "textarea") {
            const { name, value } = e.target;
            const list = [...serviceListmulti];
            list[index][name] = e.target.value;
            setServiceListmulti(list);


        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...serviceListmulti];
                    list[index][name] = url;;
                    setServiceListmulti(list);

                });
            } catch (err) {
                setMsg(err.message);
            }

        }


    };
    const handleAnswerSound2 = async (e, index) => {
        if (e.target.type === "textarea") {
            const { name, value } = e.target;
            const list = [...serviceListmulti];
            list[index][name] = e.target.value;
            setServiceListmulti(list);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...serviceListmulti];
                    list[index][name] = url;;
                    setServiceListmulti(list);

                });
            } catch (err) {
                alert(err.message)
                setMsg(err.message);
            }

        }
    };



    const handleServiceAdd1 = () => {
        console.log(serviceListmulti);
        setServiceListmulti([...serviceListmulti, { service: "" }]);
    };

    const handleServiceChange2 = (e, index) => {
        const { name, value } = e.target;
        const list = [...serviceListmulti];
        list[index][name] = value;
        setServiceListmulti(list);
    };
    const handleServiceRemove1 = (index) => {
        const list = [...serviceListmulti];
        list.splice(index, 1);
        setServiceListmulti(list);
    };



    const deleteMedia = async (e, type) => {
        e.preventDefault();
        if (type === "photo") {
            const list = [...serviceList];
            list[e.target.id]["photo"] = "";
            setServiceList(list);
        }
        else if (type === "video") {
            const list = [...serviceList];
            list[e.target.id]["video"] = "";
            setServiceList(list);
        }
        else {
            const list = [...serviceList];
            list[e.target.id]["sound"] = "";
            setServiceList(list);
        }
    }
    const deleteMedia2 = async (e, type) => {
        e.preventDefault();
        if (type === "photo") {
            const list = [...serviceListmulti];
            list[e.target.id]["photo2"] = "";
            setServiceListmulti(list);
        }
        else if (type === "video") {
            const list = [...serviceListmulti];
            list[e.target.id]["video2"] = "";
            setServiceListmulti(list);
        }
        else {
            const list = [...serviceListmulti];
            list[e.target.id]["sound2"] = "";
            setServiceListmulti(list);
        }
    }
    const handletype6 = async (e) => {
        e.preventDefault();

        if (document.getElementById("tagId").value === "Tür Seçiniz") {
            alert("Tür Seçmediniz.")
            return false;
        }
        var question;
        let questiontitle = document.getElementById("questionTitle").value.trim() || " ";
        let que = document.getElementById("questionText").value.trim() || " ";
        let questiontext = questiontitle + "__" + que;
        if (imagePath && soundPath) {
            question = {
                type: "image_sound", // İstediğin yeni tip
                url: imagePath,      // Resim URL'i
                soundUrl: soundPath, // Ses URL'i (API'nin karşılaması için yeni alan)
                text: questiontext
            };
        }
        else if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext
            };
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext
            };
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext
            };
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext
            };
        }
        var stringquestion = JSON.stringify(question)
        var obj = []
        for (let i = 0; i < serviceList.length; i++) {
            let list = {
                id: i,
                type: 0,
                service: serviceList[i]['service'],
                photo: serviceList[i]['photo'],
                photourl: serviceList[i]['addphotos'],
                sound: serviceList[i]['sound'],
                soundurl: serviceList[i]['addsounds'],
            }
            obj.push(list)
        }

        for (let i = 0; i < serviceListmulti.length; i++) {
            let list = {
                id: i,
                type: 1,
                service: serviceListmulti[i]['service'],
                photo: serviceListmulti[i]['photo2'],
                photourl: serviceListmulti[i]['addphotos2'],
                sound: serviceListmulti[i]['sound2'],
                soundurl: serviceListmulti[i]['addsounds2'],
            }
            obj.push(list)
        }
        var answertext = JSON.stringify(obj)
        let answer = obj.length / 2;


        var info = document.getElementById("infoBoxText").value;

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/ContentManager/Create";
            const data = {
                isDeleted: false,
                tagId: document.getElementById("tagId").value,
                sortId: params["sort"],
                contentType: "realmatch",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: answertext,
                notfyText: info,
                answer: answer
            };
            await axios({
                method: 'Post',
                url: url,
                data: data,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru ekleme sayfasına Dön`,
                            showDenyButton: true,
                            denyButtonText: `Aynı konuya bir soru daha ekle`,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/admin/createquestion");
                            } else if (result.isDenied) {
                                navigate("/admin/createquestionbysubject/" + params["subject"]);
                            }
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }

    useEffect(() => {
    });

    return (
        <div>
            <TitleArea msg={msg} text={"Match - Eşleştirme Oluşturma Sayfası"} />
            <Tag />
            <AddContentQuestion
                setMsg={setMsg}
                setImagePath={setImagePath}
                setVideoPath={setVideoPath}
                setSoundPath={setSoundPath}
                imagePath={imagePath}   // Eklendi
                videoPath={videoPath}   // Eklendi
                soundPath={soundPath}   // Eklendi
            />
            <hr />
            <form onSubmit={handletype6} >

                <QuestionTitleInput />
                <QuestionTextInput />

                <InfoInput />
                <hr />
                <div className="row">
                    <h6>Bilgi: Cevapta sadece dosya yada metin olmalıdır.</h6> <br /><br />
                    <div className="col-md-6">
                        <form className="App" autoComplete="off">
                            <div className="form-field">
                                <div style={{ textAlign: "center" }}><h3>{t('answers')}</h3></div>
                                <hr />
                                {serviceList.map((singleService, index) => (
                                    <div key={index} className="services">
                                        <div className="first-division" style={{ border: "1px solid black", padding: "10px" }}>
                                            <h6>Cevap {index + 1} Sol</h6>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className='mb-1'>
                                                        <label for="photo" class="form-label">{t("addPhoto")}</label>
                                                        <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAnswerPhoto(e, index)} id="photo" name="photo" />
                                                    </div>
                                                    <div class="mb-1">
                                                        <label for="addphotos" class="form-label">{t("addPhotobyUrl")}</label>
                                                        <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerPhoto(e, index)} id="addphotos" name="addphotos" />
                                                    </div>

                                                </div>
                                                <div className="col-md-6">
                                                    <div className='mb-1'>
                                                        <label for="sound" class="form-label">{t("addSound")}</label>
                                                        <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAnswerSound(e, index)} id="sound" name="sound" />
                                                    </div>
                                                    <div className='mb-1'>
                                                        <label for="addsounds" class="form-label">{t("addSoundbyUrl")}</label>
                                                        <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerSound(e, index)} id="addsounds" name="addsounds" />
                                                    </div>
                                                </div>
                                            </div>
                                            <label for="service" class="form-label">{t("answerText")}</label><i>boş ise 1 ader boşluk giriniz. (sadece video/resim vb var ise)</i>
                                            <textarea class="form-control" name="service" id="service" value={singleService.service} onChange={(e) => handleServiceChange(e, index)} required />
                                            <hr />


                                            <div className="second-division d-flex justify-content-center">
                                                {serviceList.length !== 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleServiceRemove(index)}
                                                        className="remove-btn btn btn-warning"
                                                    >
                                                        <span>Cevabı {t('remove')}</span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <br />
                                        <div className='d-flex justify-content-center'>
                                            {serviceList.length - 1 === index && serviceList.length < 6 && (
                                                <button
                                                    type="button"
                                                    onClick={handleServiceAdd}
                                                    className="add-btn btn btn-info"
                                                >
                                                    <span>{t('addAnswerOption')}</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <hr />

                            <div className="output" >
                                <div style={{ textAlign: "center" }}><h5>Oluşturulan {t('answers')}</h5></div>
                                <br />
                                {serviceList &&
                                    serviceList.map((singleService, index) => (
                                        <ul key={index} style={{ height: "285px", border: "1px solid black", padding: "10px" }}>
                                            {singleService.service &&
                                                <li >

                                                    <b> Cevap Metni:</b>{singleService.service} <br />
                                                    <b>Yüklenen foto url:</b>
                                                    <div>
                                                        {singleService.photo} <br />
                                                        <b>Harici Foto Url:</b>{singleService.addphotos}</div> <br />
                                                    <button id={index} className='btn btn-danger' onClick={(e) => deleteMedia(e, "photo")}   > resmi iptal et</button><br />
                                                    <div><b>Yüklenen ses url:</b> {singleService.sound} <br /> <b>Harici Ses Url:</b>{singleService.addsounds}</div> <br /><button id={index} className='btn btn-danger' onClick={(e) => deleteMedia(e, "sound")}   > sesi iptal et</button><br />
                                                </li>}

                                        </ul>
                                    ))}
                            </div>
                        </form>
                    </div>





                    <div className="col-md-6">
                        <form className="App" autoComplete="off">
                            <div className="form-field">
                                <div style={{ textAlign: "center" }}><h3>{t('answers')}</h3></div>
                                <hr />
                                {serviceListmulti.map((singleService, index) => (
                                    <div key={index} className="services">
                                        <div className="first-division" style={{ border: "1px solid black", padding: "10px" }}>
                                            <h6>Cevap {index + 1} Sağ</h6>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className='mb-1'>
                                                        <label for="photo2" class="form-label">{t("addPhoto")}</label>
                                                        <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAnswerPhoto2(e, index)} id="photo2" name="photo2" />
                                                    </div>
                                                    <div className='mb-1'>
                                                        <label for="addphotos2" class="form-label">{t("addPhotobyUrl")}</label>
                                                        <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerPhoto2(e, index)} id="addphotos2" name="addphotos2" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className='mb-1'>
                                                        <label for="sound2" class="form-label">{t("addSound")}</label>
                                                        <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAnswerSound2(e, index)} id="sound2" name="sound2" />
                                                    </div>
                                                    <div class="mb-1">
                                                        <label for="addsounds2" class="form-label">{t("addSoundbyUrl")}</label>
                                                        <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerSound2(e, index)} id="addsounds2" name="addsounds2" />
                                                    </div>
                                                </div>
                                            </div>
                                            <label for="service" class="form-label">{t("answerText")}</label><i>boş ise 1 ader boşluk giriniz. (sadece video/resim vb var ise)</i>
                                            <textarea class="form-control" name="service" id="service" value={singleService.service} onChange={(e) => handleServiceChange2(e, index)} required />
                                            <hr />

                                            <div className="second-division d-flex justify-content-center">
                                                {serviceListmulti.length !== 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleServiceRemove1(index)}
                                                        className="remove-btn btn btn-warning"
                                                    >
                                                        <span>Cevabı {t('remove')}</span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <br />


                                        <div className='d-flex justify-content-center'>
                                            {serviceListmulti.length - 1 === index && serviceListmulti.length < 6 && (
                                                <button
                                                    type="button"
                                                    onClick={handleServiceAdd1}
                                                    className="add-btn btn btn-info"
                                                >
                                                    <span>{t('addAnswerOption')}</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            <div className="output">
                                <div style={{ textAlign: "center" }}><h5>Oluşturulan {t('answers')}</h5></div>
                                <br />
                                {serviceListmulti &&
                                    serviceListmulti.map((singleService, index) => (
                                        <ul key={index} style={{ height: "285px", border: "1px solid black", padding: "10px" }}>
                                            {singleService.service &&
                                                <li>

                                                    <b> Cevap Metni:</b>{singleService.service} <br />
                                                    <div><b>Yüklenen foto url:</b> {singleService.photo2} <br /> <b>Harici Foto Url:</b>{singleService.addphotos2}</div> <br /><button id={index} className='btn btn-danger' onClick={(e) => deleteMedia2(e, "photo")}   > resmi iptal et</button><br />
                                                    <div><b>Yüklenen ses url:</b> {singleService.sound2} <br /> <b>Harici Ses Url:</b>{singleService.addsounds2}</div> <br /><button id={index} className='btn btn-danger' onClick={(e) => deleteMedia2(e, "sound")}   > sesi iptal et</button><br />
                                                </li>}

                                        </ul>
                                    ))}

                            </div>
                        </form>
                    </div>
                </div>
                <br />
                <SubmitButton />
            </form>
            <hr />
            <hr />

        </div>
    );
};

export default RealMatch;